import { AssessmentStatus, ExistingAssessment } from "@store/generalTypes";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { getEnumKeyByValue, parseStatus } from "@helpers/enumHelper";
import { NavLink } from "react-router-dom";
import { NavItems } from "@helpers/navigation";
import { LCheckbox } from "@components";
import { convertUTCToLocalTimeZone } from "@helpers/dateHelpers";
import { format } from "date-fns";

const checkboxPrefix = "row-assessment-";

const columnHelper = createColumnHelper<ExistingAssessment>();

export const baseResultColumns: Array<ColumnDef<ExistingAssessment, any>> = [
    {
        id: "select",
        header: ({ table }) => (
            <LCheckbox
                classes="pl-1 pt-1"
                inputName="checkAllOptions"
                checked={table.getIsAllRowsSelected()}
                onChange={table.getToggleAllRowsSelectedHandler()}
            />
        ),
        cell: ({ row }) => (
            <LCheckbox
                classes="pl-1 pt-1"
                value={row.original.id.toString()}
                inputName={checkboxPrefix + row.original.id.toString()}
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        )
    },
    columnHelper.accessor("examineeId", {
        header: () => "Examinee Id",
        cell: ({ row }) => {
            if (
                row.original.status.toLowerCase() !== AssessmentStatus.Complete.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewNeeded)?.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewComplete)?.toLowerCase()
            ) {
                return <span>{row.original.examineeId}</span>;
            } else {
                return (
                    <NavLink to={NavItems.Admin.Results.Details.path + row.original.id.toString()}>
                        {row.original.examineeId}
                    </NavLink>
                );
            }
        }
    }),
    columnHelper.accessor("visitNumber", {
        header: () => "Visit"
    }),
    columnHelper.accessor("formId", {
        header: () => "Form",
        cell: (cell) => cell.row.original.formName
    }),
    columnHelper.accessor("date", {
        header: () => "Date & Time",
        cell: (cell) => format(convertUTCToLocalTimeZone(cell.getValue()), "MM/dd/yyyy h:mm aaa")
    }),
    columnHelper.accessor("status", {
        header: () => "Status",
        cell: (cell) => `${parseStatus(cell.getValue())}`
    })
];

export const detailResultColumns = [...baseResultColumns];
detailResultColumns.splice(
    1,
    0,
    columnHelper.accessor("examineeFirstName", {
        header: () => "First Name",
        enableSorting: true,
        cell: ({ row }) => {
            if (
                row.original.status.toLowerCase() !== AssessmentStatus.Complete.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewNeeded)?.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewComplete)?.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.Invalidated)?.toLowerCase()
            ) {
                return <span>{row.original.examineeFirstName}</span>;
            } else {
                return (
                    <NavLink to={NavItems.Admin.Results.Details.path + row.original.id.toString()}>
                        {row.original.examineeFirstName}
                    </NavLink>
                );
            }
        }
    })
);
detailResultColumns.splice(
    2,
    0,
    columnHelper.accessor("examineeLastName", {
        header: () => "Last Name",
        cell: ({ row }) => {
            if (
                row.original.status.toLowerCase() !== AssessmentStatus.Complete.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewNeeded)?.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.ReviewComplete)?.toLowerCase() &&
                row.original.status.toLowerCase() !==
                    getEnumKeyByValue(AssessmentStatus, AssessmentStatus.Invalidated)?.toLowerCase()
            ) {
                return <span>{row.original.examineeLastName}</span>;
            } else {
                return (
                    <NavLink to={NavItems.Admin.Results.Details.path + row.original.id.toString()}>
                        {row.original.examineeLastName}
                    </NavLink>
                );
            }
        }
    })
);
